
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Password from "@/components/Dialog/orderDialog.vue";

@Component({
    components: {
        Password,
    },
})
export default class extends Vue {
    @Prop({ default: false }) private value!: boolean;
    @Prop({ default: "user" }) private type!: string;
    @Prop({ default: "" }) private mid!: string;

    private passWordForm: any = {
        oldPwd: "",
        newPwd: "",
        newPwdAn: "",
        reason: "",
    };
    private passWordValidate: any = {
        oldPwd: { required: true, message: "请输入旧密码", trigger: "blur" },
        newPwd: { required: true, message: "请输入密码", trigger: "blur" },
        newPwdAn: {
            required: true,
            message: "请再次输入密码",
            trigger: "blur",
        },
        reason: { required: true, message: "请输入操作原因", trigger: "blur" },
    };

    @Watch("value")
    changeStatus() {
        if (this.value) {
            this.passWordForm = {
                oldPwd: "",
                newPwd: "",
                newPwdAn: "",
                reason: "",
            };
            (this as any).$refs["pwdRef"].orderDialogVisible = true;
        }
    }

    private close() {
        this.$emit("input", false);
        this.passWordForm = {
            newPwd: "",
            newPwdAn: "",
            reason: "",
        };
    }

    private goChangePassword() {
        (this as any).$refs["ruleForm"].validate(async (valid: any) => {
            if (valid) {
                if (
                    (this as any).passWordForm.newPwd !=
                    (this as any).passWordForm.newPwdAn
                ) {
                    this.$message({
                        message: "两次密码输入的不一致！",
                        type: "warning",
                    });

                    return;
                }

                (this as any).$refs["pwdRef"].isBtnLoad = true;

                let res: any;

                if (this.type == "user") {
                    res = await (this as any).$http.setMemberPwd({
                        mid: this.mid,
                        password: (this as any).passWordForm.newPwd,
                        operate_reason: (this as any).passWordForm.reason,
                    });
                } else {
                    res = await (this as any).$http.setPersonalPwd({
                        password: (this as any).passWordForm.newPwd,
                        old_password: (this as any).passWordForm.oldPwd,
                    });
                }

                if (res.code == 1000) {
                    (this as any).$refs["pwdRef"].orderDialogVisible = false;
                    this.$message.success({
                        message: res.msg,
                        duration: 2000,
                    });
                }

                (this as any).$refs["pwdRef"].isBtnLoad = false;
            }
        });
    }
}
